module.exports = __webpack_public_path__ + "static/img/7.dc37169.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/5/1/zh/7.png
// module id = Q5dZ
// module chunks = 0